<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md>
            <profile-form
              :display-name-required="displayNameRequired"
              :show-avatar="showAvatar"
              :messaging-for-runner="messagingForRunner"
            ></profile-form>
          </ion-col>
          <ion-col v-if="userSignInWithEmail" size="12" size-md>
            <password-form></password-form>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <available-order-footer v-if="canShowFooter"></available-order-footer>
  </ion-page>
</template>

<script>
import PasswordForm from "@/components/Shared/MyProfile/PasswordForm";
import ProfileForm from "@/components/Shared/MyProfile/ProfileForm";
import PlatformService from "@/services/Platform";
import { mapGetters } from "vuex";

export default {
  title: "Account Settings",

  components: {
    "password-form": PasswordForm,
    "profile-form": ProfileForm
  },

  computed: {
    ...mapGetters("auth", [
      "userIsAdmin",
      "userIsVendor",
      "userIsRunner",
      "userSignInWithEmail"
    ]),

    displayNameRequired() {
      return this.userIsAdmin || this.userIsVendor || this.userIsRunner;
    },

    showAvatar() {
      return (
        PlatformService.isWeb() &&
        (this.userIsAdmin || this.userIsVendor || this.userIsRunner)
      );
    },

    messagingForRunner() {
      return this.userIsRunner;
    },

    canShowFooter() {
      return PlatformService.isMobile();
    }
  }
};
</script>
